import BREAKPOINTS from '../BREAKPOINTS';
/**
 * @since 0.28.1
 * @component
 */

type BreakpointsType = Lowercase<keyof typeof BREAKPOINTS>[];

export default Object.keys(BREAKPOINTS).map((breakpoint) => breakpoint.toLowerCase()) as BreakpointsType;
